// Royalty-free placeholder imagery. Swap any `url` for the client's own
// photography later — the `alt` text should be updated to match.

export const MEDIA = {
  heroBackground: {
    url: "https://images.unsplash.com/photo-1711447395363-5595964fd7ab?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Grassroots football pitch under floodlights at dusk, ready for matchday coverage",
  },
  actionShot1: {
    url: "https://images.unsplash.com/photo-1603291697926-7e5822ed1ac5?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Player in red kit running with the ball during a grassroots women's football match",
  },
  actionShot2: {
    url: "https://images.pexels.com/photos/32266274/pexels-photo-32266274.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    alt: "Two footballers competing for the ball during a women's grassroots match",
  },
  crowd: {
    url: "https://images.unsplash.com/photo-1629217855633-79a6925d6c47?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Fans watching a football match from the stands",
  },
  commentatorProfile: {
    url: "https://images.unsplash.com/photo-1485579149621-3123dd979885?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Microphone set up for live football commentary, placeholder for commentator profile photo",
  },
  training: {
    url: "https://images.pexels.com/photos/9517938/pexels-photo-9517938.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
    alt: "Woman training on a grassroots football pitch",
  },
  matchdayHero: {
    url: "https://images.unsplash.com/photo-1783428933716-43b3da7d0d43?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Players training on a grassroots football pitch at sunset",
  },
  socialsHero: {
    url: "https://images.unsplash.com/photo-1665413811870-5b29a250f64a?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Crowd of football fans supporting from the stands",
  },
  aboutAction: {
    url: "https://images.unsplash.com/photo-1528162841823-9e55a8cc2f58?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Two players challenge for the ball during a women's grassroots football match",
  },
  contentThumbnails: {
    "Match Commentary": {
      url: "https://images.unsplash.com/photo-1643917367212-018cf11bf790?crop=entropy&cs=srgb&fm=jpg&q=85",
      alt: "Commentary microphone pitch-side at a grassroots football match",
    },
    Interviews: {
      url: "https://images.unsplash.com/photo-1612151387614-0d29a04ff5f3?crop=entropy&cs=srgb&fm=jpg&q=85",
      alt: "Broadcast desk set up for post-match interviews and analysis",
    },
    Highlights: {
      url: "https://images.pexels.com/photos/32266274/pexels-photo-32266274.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
      alt: "Match highlight moment from a women's grassroots football fixture",
    },
    "Matchday Content": {
      url: "https://images.unsplash.com/photo-1629217855633-79a6925d6c47?crop=entropy&cs=srgb&fm=jpg&q=85",
      alt: "Matchday atmosphere at a grassroots football fixture",
    },
    "Behind the Scenes": {
      url: "https://images.pexels.com/photos/9517938/pexels-photo-9517938.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
      alt: "Behind the scenes at a grassroots women's football training session",
    },
    Other: {
      url: "https://images.unsplash.com/photo-1629977009896-44a567a0543c?crop=entropy&cs=srgb&fm=jpg&q=85",
      alt: "Close-up of a football and boots on the grassroots pitch",
    },
  },
};
